var map = {
	"./ar/home/HomeView.vue": [
		3967,
		4689,
		3967
	],
	"./bn/home/HomeView.vue": [
		123,
		4689,
		123
	],
	"./en/home/HomeView.vue": [
		1671,
		4689,
		1671
	],
	"./fa/home/HomeView.vue": [
		1867,
		4689,
		1867
	],
	"./ur/home/HomeView.vue": [
		404,
		4689,
		404
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4034;
module.exports = webpackAsyncContext;